import React, { useState, useEffect, useCallback } from 'react';
import _get from 'lodash/get';

// Components
import SelectInput from './SelectInput';

// Style
import withStyles from '@material-ui/core/styles/withStyles';
import { defineStyles, Classes } from 'styles/defineStyles';
const styles = defineStyles(theme => {
  return {
    root: {
      marginBottom: theme.spacing(2),
    },
  };
});

interface Props {
  categoryId?: string;
  onChange: (value: any) => void;
  globalConfig: any;
  classes: Classes<typeof styles>; // HOC
}

function AddAttribute(props: Props) {
  const { classes, categoryId, onChange, globalConfig } = props;

  const initialState = createInitialState(categoryId, globalConfig);
  const [selectInputs, setSelectInputs] = useState(initialState);

  useEffect(() => {
    const initialState = createInitialState(categoryId, globalConfig);
    setSelectInputs(initialState);
  }, [categoryId]);

  const handleChange = useCallback(
    (newSelectInputValue, selectInputIndex) => {
      const clonedSelectedInputs = selectInputs.slice(0, selectInputIndex + 1);
      if (newSelectInputValue) {
        clonedSelectedInputs.push(newSelectInputValue);
      }

      setSelectInputs(clonedSelectedInputs);

      // User has reached a list of fields
      if (newSelectInputValue && !newSelectInputValue.children) {
        onChange({
          baseField: newSelectInputValue.id,
          type: newSelectInputValue.type,
        });
      } else {
        onChange({
          baseField: undefined,
          type: undefined,
        });
      }
    },
    [selectInputs, onChange],
  );

  return (
    <div className={classes.root}>
      {selectInputs.map((category, index) => {
        // Every category has a children Prop. If one isn't there the field has been selected
        if (!category.children) {
          return null;
        }

        return (
          <SelectInput
            category={category}
            onChange={handleChange}
            globalConfig={globalConfig}
            selectInputIndex={index}
            key={category.id}
          />
        );
      })}
    </div>
  );
}

export default withStyles(styles)(AddAttribute);

function createInitialState(categoryId: string | undefined, globalConfig: any) {
  const rootCategory =
    categoryId && _get(globalConfig, `categories[${categoryId}]`)
      ? globalConfig.categories[categoryId]
      : globalConfig.categories.basic;

  return [rootCategory];
}
